import React from "react";
import { FaCalendarAlt, FaMedal, FaTrophy } from "react-icons/fa";

import {
  formatShortDate,
  isPodium,
  parseFightResults,
} from "../utils/statistiquesJudokaUtils";

function ResultBadge({ result }) {
  const styles = {
    "✅": "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
    "❌": "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200",
    N: "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white/70",
    F: "bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200",
    D: "bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-200",
  };

  return (
    <span
      className={`inline-flex h-8 min-w-8 items-center justify-center rounded-2xl px-2 text-xs font-bold ${
        styles[result] || styles.N
      }`}
    >
      {result}
    </span>
  );
}

function RecentResultsTimeline({ events = [] }) {
  if (!events.length) {
    return null;
  }

  return (
    <section className="mt-6 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-6">
      <div className="mb-6">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-600 dark:text-sky-200">
          Dernières performances
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          Timeline des résultats
        </h2>
      </div>

      <div className="space-y-4">
        {events.map((event, index) => {
          const results = parseFightResults(event?.AdherentEvent?.resultats);
          const classement = event?.AdherentEvent?.classement || "N.C.";
          const podium = isPodium(classement);

          return (
            <article
              key={`${event?.id || event?.event_id || "event"}-${index}`}
              className="relative rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.04]"
            >
              <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-600 shadow-sm dark:bg-white/10 dark:text-white/70">
                      <FaCalendarAlt />
                      {formatShortDate(event?.start)}
                    </span>

                    {podium && (
                      <span className="inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-bold text-amber-700 dark:bg-amber-500/10 dark:text-amber-200">
                        <FaMedal />
                        Podium
                      </span>
                    )}
                  </div>

                  <h3 className="mt-3 font-titre text-xl font-bold text-slate-950 dark:text-white">
                    {event?.titre || "Compétition"}
                  </h3>

                  <p className="mt-1 text-sm font-medium text-slate-500 dark:text-white/50">
                    Classement : <span className="font-bold">{classement}</span>
                  </p>
                </div>

                <div className="flex flex-wrap gap-2 sm:justify-end">
                  {results.length > 0 ? (
                    results.map((result, resultIndex) => (
                      <ResultBadge
                        key={`${result}-${resultIndex}`}
                        result={result}
                      />
                    ))
                  ) : (
                    <span className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500 dark:bg-white/10 dark:text-white/50">
                      <FaTrophy />
                      Aucun combat
                    </span>
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default RecentResultsTimeline;